import { Button } from '@mui/material';
import { Box } from '@mui/system';
import LoadingIndicator from '../LoadingIndicator';

const FormButtons = (props: {
  PrevButtonText: string;
  SubmitButtonText: string;
  PrevButtonHandler: any;
  isLoading: boolean;
}): JSX.Element => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Button onClick={() => props.PrevButtonHandler()} id="CancelButton">
        {props.PrevButtonText}
      </Button>
      {props.isLoading && <LoadingIndicator />}
      <Button type="submit" variant="contained" disabled={props.isLoading}>
        {props.SubmitButtonText}
      </Button>
    </Box>
  );
};

export default FormButtons;
